module.exports = __webpack_public_path__ + "img/2.bac8c28d.jpg";